import { isNotEmptyString } from '@weft/utils';
import { formatNumber } from '@weft/utils';
import React from 'react';
import { twMerge } from 'tailwind-merge';

type UsageProductVariantHeaderViewProps = {
  name?: string;
  description?: string;
  price?: number;
  costEstimation?: number;
  className?: string;
  isProductTitle?: boolean;
};

export const UsageProductVariantHeaderView:React.FC<UsageProductVariantHeaderViewProps> = ({
  name,
  description,
  price,
  costEstimation,
  className: externalClassName,
  isProductTitle = false,
}) => {
  const className = twMerge('flex justify-between', externalClassName);
  const productVariantHasName = isNotEmptyString(name);

  return (
    <div className={className}>
      {productVariantHasName && (
        <div className="pb-6">
          <div className={twMerge('text-lg font-medium', isProductTitle ? 'text-placeholder' : 'text-black')}>{name}</div>
          <div className="text-label2 text-sm">{description}</div>
        </div>
      )}
      {costEstimation ? (
        <div className="text-right">
          <div className="text-placeholder text-sm">Cost Estimation</div>
          <div className="text-xl font-medium text-black">
            <span className="text-base">$</span>
            {formatNumber(costEstimation)}
          </div>
          <p className="text-price text-sm">{`$${formatNumber(price)} X 12`}</p>
        </div>
      ) : <></>}
    </div>
  );
};